import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Card ({ data }) {
  const navigate = useNavigate()

  const handleMenu = menu => {
    navigate(`/${menu}`)
    window.scrollTo(0, 0) 
  }

  return (
    <div
      className='w-[410px] h-[520px] mobile:w-full mobile:ml-0 cursor-pointer group relative mobile:mb-5  rounded-2xl mobile:h-full'
      onClick={() => handleMenu(data.nav)}
    >
      <div className='w-full flex flex-col overflow-hidden relative rounded-2xl'>
        <img
          src={data.image}
          alt={data.title}
          className='h-[520px] w-[410px] mobile:h-full mobile:w-full object-cover transition-transform duration-[2000ms] ease-in-out group-hover:scale-110 group-hover:blur-sm'
        />

        <div
          className='absolute inset-0 flex flex-col items-start justify-end p-4 h-full bg-gradient-to-t from-black/60
         to-transparent transition-all duration-[3500ms] group-hover:items-start group-hover:justify-end group-hover:from-black/80  rounded-2xl ease-in-out'
        >
          <p
            className='font-inter-bold text-[48px] uppercase leading-[48px] text-white 
                      temp:text-[34px]
                      tablet:text-[20px] tablet:leading-[28px] mb-[120px] px-2 
                      group-hover:translate-y-[-10%] group-hover:text-xxl group-transform translate-y-full 
                       group-hover:mt-20, group-hover:mb-5 group-hover:leading-[48px] group-hover:px-2  transition-all duration-[3000ms] ease-in-out '
            style={{ lineHeight: 1.01, lineBreak: 1 }}
          >
            {data.title}
          </p>
          <div className='px-2'>
            <div className='group relative'>
              <hr className='w-0 h-[1px] bg-white transition-all duration-[800ms] ease-in-out  group-hover:w-1/3 group-hover:mb-4 ' />
            </div>
            <p
              className='text-[0px] leading-[24px] text-white/55 tablet:text-[16px] opacity-0 translate-y-4
            group-hover:opacity-100 group-hover:translate-y-0 group-hover:text-[16px] group-hover:text-justify group-hover:mb-20'
            >
              {data.desc}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
